import CtaButtonGroup, { CtaType } from '@/components/molecules/CtaButtonGroup';
import Image from 'next/image';
import React from 'react';

interface AboutCreatorProps {
  name: string;
  imageUrl: string;
  description: string;
  benefits: string[];
  gradient: boolean;
  ctas: CtaType[];

}

const AboutCreator: React.FC<AboutCreatorProps> = ({ name, imageUrl, description, benefits, gradient, ctas }) => {
    
  return (
    <div className={`relative w-full overflow-hidden ${
        gradient ? "bg-aurora1" : "bg-purple-0"
      } py-6 sm:py-12`}>
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-semibold mb-6 text-center">
          Meet your expert, <span className="text-purple-3">{name}</span>
        </h2>
        <div className="flex flex-col md:flex-row gap-8">
          <div className="md:w-1/3">
            <Image
              src={imageUrl}
              alt={name}
              width={300}
              height={400}
              className="rounded-lg shadow-lg"
            />
          </div>
          <div className="md:w-2/3 flex gap-8 justify-start flex-col">
            <p className="text-slate02 mb-4 text-body">{description}</p>
            <div className="flex flex-col gap-4 text-body text-slate02">
            {benefits && benefits?.map((item) => {
              return (
                <div key={item} className="flex w-full items-start gap-1">
                  <div className="h-5 w-5">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.7578 12.9461C2.13062 11.3189 2.13062 8.68074 3.7578 7.05356L7.05363 3.75774C8.68081 2.13055 11.319 2.13055 12.9462 3.75773L16.242 7.05356C17.8692 8.68074 17.8692 11.3189 16.242 12.9461L12.9462 16.2419C11.319 17.8691 8.68081 17.8691 7.05363 16.2419L3.7578 12.9461Z"
                        stroke="#6059FF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.0939 8.92236L9.47696 11.5393L7.90381 9.97113"
                        stroke="#6059FF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="text-body">{item}</span>
                </div>
              );
            })}
            </div>
            <div>
              <CtaButtonGroup align="sm:left" ctas={ctas} affiliateButton={true}  />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutCreator;